import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Allergen, IntakeAllergen } from '../models/index';
import { Api, Session, IntakeApi } from '../services/index';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import {TranslateService} from '@ngx-translate/core'; 


@Component({
  selector: 'app-exam-allergies',
  styleUrls: ['exam-have-allergies.css'],
  templateUrl: './exam-have-allergies.html'
})

export class ExamHaveAllergies implements OnInit {
  // @ViewChild('myModal') _modalMsg: ElementRef;
  @ViewChild('modalDialog') public modalDialog: DialogComponent;
  public target: string = "#targetModal";
  public width: string = '95%';
  public height: string = '100%';
  public header: string = 'Search Allergies';
  // Initialize Button to open the modal Dialog
  // public buttons: Object[] = [{ click: this.dlgButtonClick, buttonModel: { content: 'Close', cssClass: 'e-flat', isPrimary: true } }];
  public isModal: Boolean = true;
  public animationSettings: Object = { effect: 'None' };
  public hide: any;
  position: object = { X: 'top', Y: 'center' };
  public dialogdragging: Boolean = true;
  public showCloseIcon: Boolean = true;
  public dialogResize: Boolean = true;

  allergenList: Allergen[] = []; 
  allergenSearchResults: Allergen[] = [];  //Allergen[] = []; 
  allergies: Allergen[] = []; 
  hasNoResults: boolean = false;
  intakeAllergenList: IntakeAllergen[] = [];
  patientId: number;
  searching: boolean = false;
  searchText: string = '';
  loading: boolean = false;


  modalBtnClick() {
   
      this.modalDialog.show(); 
    }
  
    // Close the Dialog, while clicking "OK" Button of Dialog
    public dlgButtonClick: EmitType<Object> = () => {
      this.searchText = '';
      this.allergenSearchResults = null;
      this.hide();      
    }
   
    public dialogClose: EmitType<Object> = () => {
      this.searchText = '';
      this.allergenSearchResults = null;
      this.modalDialog.visible = false;
  }
  
    // Close the modal Dialog on overlay click
    public overlayClick(): void {
      this.searchText = '';
      this.allergenSearchResults = null;
      this.modalDialog.hide();
  
    }

  
  constructor(private api: Api, 
              private intakeApi: IntakeApi,
              private route: ActivatedRoute,
              private changeDetectorRef: ChangeDetectorRef,
              private router: Router,
              private translateService: TranslateService,
              private session: Session) {
    this.patientId = this.route.snapshot.params['patientId'] || ''; 
    
    // let alergens = this.api.getIntakeAllergens(this.session.serverIntake.intakeId);
    let alergens = this.intakeApi.getIntakeAllergens(this.session.serverIntake.intakeId)
    alergens.subscribe(response => {
      console.log(`
      ***
      allergy: ${JSON.stringify(response)}
      ***
      `)
      this.intakeAllergenList = response;
      for (let i = 0; i < this.intakeAllergenList.length; i++) {
        let a = new Allergen();
        a.description = this.intakeAllergenList[i].allergenName;
        this.allergies.push(a);
      }

      // if (!this.changeDetectorRef['destroyed']) {
      //   this.changeDetectorRef.detectChanges();
      // }
    })
  }

  ngOnInit() {
    this.translateService.get('MODAL_SEARCH_ALLERGIES').subscribe((res: string) => {
      if(res){
        this.header  = res;
      }else{
        this.header  = 'Search Allergies';
      }
      
      console.log(res);
    });  
  }

  getIntakeLOB(){
    return this.session.intakeLob;
  }

  trim(value) {
    return value.trim();
  }

  noAllergies() {
    this.router.navigate(['exam-taking-any-medications/' + this.patientId]);
  }
  
  addAllergen(allergen) {    
    let a = new Allergen();
    a.id = allergen.id;
    a.description = allergen.description;
    a.allergenTypeDescription = allergen.allergenTypeDescription;

    this.allergies.push(a);
    this.modalDialog.visible = false;
    // (<any>$(this._modalMsg.nativeElement)).modal('hide');
  }

  removeAllergen(allergen) {
    for (let i = 0; i < this.allergies.length; i++) {
      if (this.allergies[i] == allergen) {
        this.allergies.splice(i, 1);
      }
    }
  }
  
  updateAllergens() {
    this.loading= true;
    if (this.allergies.length > 0) {      
      let updateAllergens = new Array<string>();
      for (let i = 0; i < this.allergies.length; i++) {
        if (this.allergies[i].allergenTypeDescription) {
          updateAllergens.push(this.allergies[i].description + ' ' + this.allergies[i].allergenTypeDescription)
        } else {
          updateAllergens.push(this.allergies[i].description)
        }
      }
      this.api.insertIntakeAllergens(this.session.serverIntake.intakeId, updateAllergens).subscribe(res => {
        this.session.intakeAllergens = this.allergies;
        this.loading= false;
        this.router.navigate(['exam-taking-any-medications/' + this.patientId]);

      })
    } else {
      this.loading = false;
      this.router.navigate(['exam-taking-any-medications/' + this.patientId]);
    }
  }
  
  searchAllergies() {
    this.allergenSearchResults = [];
    this.searching = true;
    this.hasNoResults = false;
    this.api.searchAllergens(this.searchText.trim()).subscribe((result: any) => {
        this.allergenSearchResults = result;
        this.searching = false;
        if (this.allergenSearchResults.length ===  0 ) {
          let a = new Allergen();
          a.allergenTypeDescription = 'Not Specified';
          a.description = this.searchText.trim();
          a.id = 0;
          this.allergenSearchResults.push(a);
          this.searchText = '';
        }else{
          this.searchText = '';
        }

      },
      err => {
        console.log(err)
        this.searching = false;
        let a = new Allergen();
        a.allergenTypeDescription = 'Not Specified';
        a.description = this.searchText.trim();
        a.id = 0;
        this.allergenSearchResults.push(a);
        this.searchText = '';
    })
  }
}
